/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-07-26 08:00:56
 *
 *******************************************************/
// @flow

import React from 'react';
import { Field } from 'redux-form';
import { Stack, TextStyle } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';

import { RenderCheckbox } from 'src/components/views/common/forms/render-checkbox';

// DONE
const ProductSuggestionDisplay = props => {
  const { i18n } = props;
  return (
    <div className="product-suggestion">
      <TextStyle variation="strong">
        {i18n.translate(
          'AdminHTML.InstantSearchDisplay.ISWWithResults.displayProduct_Checkbox_Label'
        )}
      </TextStyle>
      <div className="groupFields">
        <Stack distribution="fillEvenly">
          <Field
            name="productAvailable"
            component={RenderCheckbox}
            label={i18n.translate(
              'AdminHTML.InstantSearchDisplay.ISWWithResults.productSuggestionDisplay_Field1_Label'
            )}
          />

          <Field
            name="showSuggestionProductSalePrice"
            component={RenderCheckbox}
            label={i18n.translate(
              'AdminHTML.InstantSearchDisplay.ISWWithResults.productSuggestionDisplay_Field2_Label'
            )}
          />
        </Stack>
        <Stack distribution="fillEvenly">
          <Field
            name="showSuggestionProductVendor"
            component={RenderCheckbox}
            label={i18n.translate(
              'AdminHTML.InstantSearchDisplay.ISWWithResults.productSuggestionDisplay_Field3_Label'
            )}
          />
          <Field
            name="showSuggestionProductSku"
            component={RenderCheckbox}
            label={i18n.translate(
              'AdminHTML.InstantSearchDisplay.ISWWithResults.productSuggestionDisplay_Field4_Label'
            )}
          />
        </Stack>
        <Stack distribution="fillEvenly">
          <Field
            name="showSuggestionProductPrice"
            component={RenderCheckbox}
            label={i18n.translate(
              'AdminHTML.InstantSearchDisplay.ISWWithResults.productSuggestionDisplay_Field5_Label'
            )}
          />
          <Field
            name="showSuggestionProductImage"
            component={RenderCheckbox}
            label={i18n.translate(
              'AdminHTML.InstantSearchDisplay.ISWWithResults.productSuggestionDisplay_Field6_Label'
            )}
          />
        </Stack>
      </div>
    </div>
  );
};
export default withI18n()(ProductSuggestionDisplay);
